var exports = {
  "O3": "xa15a2ab7--65dbd7--underground",
  "S3": "xa15a2ab7--65dbd7--underground_time",
  "VL": "xa15a2ab7--65dbd7--underground_link",
  "Vl": "xa15a2ab7--65dbd7--under_construction",
  "Kk": "xa15a2ab7--65dbd7--icon",
};

module.exports = exports;
